import { render } from "./TheFooter.vue?vue&type=template&id=739f89f8&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=739f89f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-739f89f8"

export default script